import styled from 'styled-components'

const HomePageStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 80px;
`
export default HomePageStyled
